import React, { useState, useEffect } from "react";
import {Table, Pagination, Button, Empty, Avatar, Spin, Badge, Radio, Tooltip} from "antd";
import axios from "axios";
import { Chip } from "@mui/material";
import breakfastIcon from "../../assets/breakfastOrederingIcon.png";
import lunchIcon from "../../assets/lunchOrderingIcon3.png";
import { debounce } from "lodash";
import "../../styles/OrderHistorySpinnerStyle.css";
import "../../styles/OrderHistoryTableStyle.css";
import OrderHistoryLoaderLayout from "../screenLoader/OrderHistoryLoaderLayout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBowlFood, faMugSaucer, faPizzaSlice} from "@fortawesome/free-solid-svg-icons";
export default function OrderHistoryTable({upcoming}) {
  const [presentOrderHistory, setPresentOrderHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalBreakfast, setTotalBreakfast] = useState(0);
  const [totalLunch, setTotalLunch] = useState(0);
  const [type, setType] = useState("all");
  const PAGE_SIZE = 8;
  const [loading, setLoading] = useState(false);
  const [totalOrderOfLoggedInUser, setTotalOrderOfLoggedInUser] = useState("");
  const base_url = process.env.REACT_APP_BASE_URL;

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: "20%",
      align: "left",
    },
    {
      title: "Menu",
      dataIndex: "menu",
      key: "menu",
      align: "left",
      width: "50%",
    },
    {
      title: "Ordered Time",
      dataIndex: "orderTime",
      key: "orderTime",
      width: "20%",
      align: "center",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "10%",
      align: "right",
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const accessToken = sessionStorage.getItem("accessToken");
      const user_id = sessionStorage.getItem("userData");

      const response = await axios.get(
          `${base_url}/api/v1/client/order/history/${user_id}?page=${currentPage}&upcoming=${upcoming}&type=${type}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
      );

      const { data } = response;
      setPresentOrderHistory(data.data.clientOrderHistory);
      setTotalOrderOfLoggedInUser(data.data.getTotalOrders);
      setTotalBreakfast(data.data.totalBreakfast);
      setTotalLunch(data.data.totalLunch);
    } catch (error) {
      //console.error(error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const pageCount = Math.ceil(totalOrderOfLoggedInUser / 8);

  const data = presentOrderHistory.map((order, index) => {
    let iconSrc = order.type === "Breakfast" ? breakfastIcon : lunchIcon;
    let chipBackgroundColor =
      order.type === "Breakfast" ? "#CAEFD1" : "#fff2cd";
    return {
      key: index,
      date: (
        <div>
          {order.date},&nbsp;
          {order.weekDay}
        </div>
      ),
      menu: order.menu,
      orderTime: (
        <div>
          {order.orderDate},&nbsp;
          {order.orderTime}
        </div>
      ),
      type: (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Chip
            avatar={<Avatar alt="orderTypeImg" src={iconSrc} />}
            label={order.type}
            size="small"
            style={{
              width: "95px",
              display: "flex",
              backgroundColor: chipBackgroundColor,
              borderRadius: 0,
            }}
          />
        </div>
      ),
    };
  });

  const handlePaginationChange = (page) => {
    setCurrentPage(page);
    if (page < 1) {
      setCurrentPage(page + 1);
    }
    if (page > pageCount) {
      setCurrentPage(pageCount);
    }
  };

  const onChangeMealType = (e) => {
    setCurrentPage(1);
    setType(e.target.value);
  };

  useEffect(()=>{
    fetchData();
  }, [type])

  return (
    <>
      <>
        <Badge.Ribbon
          text={`${upcoming==1?"Upcoming":"Past"} Order(s)`}
          color="rgb(0,176,240)"
          placement="start"
        >
          <h4 style={{ fontSize: "19px" }} className="text-muted"></h4>
        </Badge.Ribbon>
      </>
      <div style={{ marginTop: "10px", textAlign: "right" }}>
        <Pagination
          current={currentPage}
          total={totalOrderOfLoggedInUser}
          pageSize={PAGE_SIZE}
          onChange={handlePaginationChange}
        />
        <div style={{marginTop: "20px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            {(type=="breakfast"||type=="all")?(<Tooltip placement="top" title={'Breakfast Ordered'}>
              <div className="stat-child-sm">
                <FontAwesomeIcon icon={faMugSaucer} className="child-icon-sm cl-orange"/>
                <div>{parseInt(totalBreakfast)}</div>
              </div>
            </Tooltip>):''}
            {type=="all"?<div style={{width: "2px", height: "20px", background: "lightgrey", marginRight: "20px"}} />:""}
            {(type=="lunch"||type=="all")?(
              <Tooltip placement="top" title={'Lunch Ordered'}>
              <div className="stat-child-sm">
              <FontAwesomeIcon icon={faPizzaSlice} className="child-icon-sm cl-green"/>
              <div>{parseInt(totalLunch)}</div>
              </div>
              </Tooltip>):''}
          </div>
          <div>
            <Radio.Group
                onChange={onChangeMealType}
                defaultValue={type}
                style={{
                  padding: "4px", // Add padding for spacing and to create borders
                  border: "1px solid #ccc", // Add a light border
                  borderRadius: "7px",
                }}
            >
              <Radio value="all">
                All
              </Radio>
              <Radio value="breakfast" >
                Breakfast
              </Radio>
              <Radio value="lunch" >
                Lunch
              </Radio>
            </Radio.Group>
          </div>
        </div>
        {loading && (
          <OrderHistoryLoaderLayout screenLoaderText="Loading Order History..." />
        )}
      </div>



      {presentOrderHistory.length > 0 && !loading ? (
        <>
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            style={{ marginTop: "30px" }}
            size="small"
          />
        </>
      ) : totalOrderOfLoggedInUser === 0 && !loading ? (
        <div style={{ textAlign: "center", marginTop: "140px" }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_DEFAULT}
            description={
              <p style={{ color: "#ababab" }}>No Order History found !</p>
            }
          />
        </div>
      ) : null}
    </>
  );
}
